export default __webpack_public_path__ + "static/media/Mail.b13ea98a.svg";